import React from "react";
import AudienceForm from "../campaigns/audience/audienceForm";
import ApiService from "../../Services/ApiService";
import AlertService from "../../Services/AlertService";
import { Form, Field, Formik } from "formik";
import queryString from "query-string";
import LoadingScreen from "../misc/loading";
import { extendWith } from "lodash";


class ClientAudience extends React.Component {
    constructor(props) {
        super(props);

        let params = queryString.parse(this.props.location.search);
        let clientID = params.client_id;

        this.state = {
            data: {
                id: '',
                name: '',
                client_id: clientID ?? '',
                is_default: 1,
                job_functions: [],
                job_titles: [],
                locations: [],
                seniorities: [],
                job_skills: [],
                locale_id: 4 //english
            },
            is_loading: true,
            is_new: true,
            header: "New Client",
        };
    }

    componentDidMount() {
        let params = queryString.parse(this.props.location.search);
        if (params) {
            let id = params.id;
            if (id) {
                this.getClientAudience(id)
            } 

            this.setState({...this.state, is_loading: false})

        }
    }

    getClientAudience = (id) => {
        const url = "/api/clients/audience/" + id;
        ApiService.get(url)
            .then(response => {
                let audience = response.data.Audience;

                if (audience) {

                    let jobFunctions = audience.job_functions;
                    let jobFunctionIDs = jobFunctions ? Object.keys(jobFunctions) : [];
                    audience.job_functions = jobFunctionIDs.map(id => parseInt(id));

                    this.setState({
                        data: audience,
                        client_id: audience.client_id,
                        is_loading: false,
                        is_new: false,
                        header: "Edit Client Audience"
                    })
                }
            })
            .catch(error => {
                console.log(error);
            })
    }

    saveClientAudience = () => {

        if (this.state.is_new) {
            ApiService.post("/api/clients/add-audience", this.state.data)
                .then(response => {
                    this.props.history.push("/clients/audience?client_id=" + this.state.data.client_id);
                    AlertService.success('Audience created successfully');
                })
                .catch( error => {
                    AlertService.error('Oops! There was an error creating the Audience');
                })
        } else {
            if (window.confirm('Are you sure you want to save your changes to this audience?')) {
                ApiService.post('/api/clients/update-audience', this.state.data)
                    .then(response => {
                        this.props.history.push("/clients/audience?client_id=" + this.state.data.client_id);
                         AlertService.success('Audience updated successfully');
                    });
            }
        }

    }

    handleFormChange(property, value) {
        this.setState({data: {...this.state.data, [property]: value}});
    }

    handleChange = (e) => {
        const {name, value} = e.target;
        this.setState({data: {...this.state.data, [name]: value}})
    }

    setDefault = () => {
        this.setState({data: {...this.state.data, is_default: 1}}, () => {
            if (window.confirm('Are you sure you want to set this audience as the default?')) {
                ApiService.post('/api/clients/update-audience', this.state.data)
                    .then(response => {
                        this.props.history.push("/clients/audience?client_id=" + this.state.data.client_id);
                    });
            }
        })
    }

    render = () => {
        let defaultButton = null;
        if (!this.state.data.is_default) {
            defaultButton = (<button onClick={this.setDefault}>Set as Default</button>)
        }

        let form = (
            <div>
                <Formik
                    enableReinitialize
                    initialValues={this.state.data}
                    onSubmit={this.saveClientAudience}
                    render={({ values, errors, touched, isSubmitting, handleBlur }) => {

                        return (
                            < Form className="form-container">
                                <div className="overview">

                                    <div className="form-col">


                                        <div className="input-group">
                                            {defaultButton}
                                        </div>

                                        <div className="input-group">
                                            <label>
                                                <span>Audience Name</span>
                                                <Field
                                                    type="text"
                                                    name="name"
                                                    value={values.name}
                                                    onChange={this.handleChange}
                                                />
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </Form>
                        )
                    }}>
                        
                </Formik>

                <div className="audience-form-container">
                    <AudienceForm data={this.state.data} onFormChange={this.handleFormChange.bind(this)} ranking={true} />
                    <div>
                        <button type="button" className="outline" onClick={() => { this.props.history.push("/clients/audience?client_id=" + this.state.data.client_id) }} >
                            Cancel
                        </button>
                        <button type="button" onClick={this.saveClientAudience}>
                            Submit
                        </button>
                    </div>
                </div>
            </div>
        )

        if (!this.state.is_loading) {
            return (<div className="page-main">
                <div className="page-content">
                    {form}
                </div>
            </div>)
        } else {
            return <LoadingScreen />;
        }
    }
}

export default ClientAudience